import React from 'react'

const ClassRoomUnit = ({varCRItem,onChangeCRHandler}) => {

  return (
    <div className="chk-group flex">
      <input type="checkbox" id={varCRItem.cr_name} checked={varCRItem.cr_status===2||false} onChange={e=>onChangeCRHandler(e,varCRItem.cr_name)}/>
      <label htmlFor={varCRItem.cr_name}>{varCRItem.full_name}</label>
    </div>
  )
}
export default ClassRoomUnit;